<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 lg6>
        <h1 class="text-center" id="page-heading">Privacy Notice</h1>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 lg6>
        <div v-html="content"></div>
      </v-flex>
    </v-layout>
    <BackHome />
  </v-container>
</template>

<script>
import BackHome from '../components/BackHome'
export default {
  components: {
    BackHome
  },
  name: 'Privacy',
  mounted() {
    this.axios.get('/data/privacy.html').then( (response) => {
      if(response.data) {
        this.content = response.data
      }
    });
  },
  data: () => ({
    content: ''
  }),
};
</script>
